import {
    openDesktopNav,
    closeDesktopNav,
    closeAllDesktopMainNavs,
    closeAllDesktopUtilityNavs,
    openLoginDropdown,
    closeLoginDropdown,
    closeAllDesktopDropdowns,
    openDesktopLocationSelect,
    closeDesktopLocationSelect
} from '../menus.js';

function initMainNavKeyboardNavigation() {
    //main nav keyboard navigation
    $('body').on('keydown', '.top-subnav', function (e) {
        var menu = $(e.target).closest('.trigger-container').find('.meganav-trigger, .standard-link'),
            submenu,
            submenuContainer;

        if (e.which == 27) { //esc

            submenu = $(e.target).closest('.trigger-container').find('.submenu-open');
            submenuContainer = submenu.closest('.meganav-submenu-container');

            if (submenu.length > 0) {

                closeDesktopNav(menu);
                menu.addClass('keyboard-focus').on('blur', function () {
                    $(this).off('blur').removeClass('keyboard-focus');
                }).get(0).focus();

                return false;
            }
        } else if (e.which == 40 || e.which == 13) { //down arrow or enter

            submenu = menu.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
            submenuContainer = submenu.closest('.meganav-submenu-container');

            if (submenu.length > 0) {

                //top level
                if ($(e.target).is('.meganav-trigger')) {

                    if (submenu.is(':not(.submenu-open')) {
                        //close all other menus
                        closeAllDesktopMainNavs();
                        closeAllDesktopUtilityNavs();

                        //open submenu
                        openDesktopNav(menu);
                    }

                    //select first submenu item
                    submenu.find('a').first().addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();

                    return false;

                //move down inside submenu
                } else if ($(e.target).is('.meganav-submenu-inner-wrapper a')) {
                    //select next submenu item
                    let anchor = $(e.target).next('a');

                    //wrap to first item
                    if (anchor.length == 0) {
                        if ($(e.target).is('.nav-highlight a')) {
                            anchor = submenu.find('.nav-submenu-item').first();
                        } else {
                            anchor = submenu.find('.nav-highlight a');
                        }
                    }

                    //focus next submenu item
                    if (anchor.length > 0) {
                        anchor.addClass('keyboard-focus').on('blur', function () {
                            $(this).off('blur').removeClass('keyboard-focus');
                        }).get(0).focus();
                    }

                    return false;
                }
            }

        } else if (e.which == 38) { //up arrow
            submenu = menu.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
            submenuContainer = submenu.closest('.meganav-submenu-container');

            if (submenu.length > 0) {
                //top level
                if ($(e.target).is('.meganav-trigger')) {

                    if (submenu.is(':not(.submenu-open')) {
                        //close all other menus
                        closeAllDesktopMainNavs();
                        closeAllDesktopUtilityNavs();

                        //open submenu
                        openDesktopNav(menu);
                    }

                    //select last submenu item
                    submenu.find('a').last().addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();

                    return false;

                //move up inside submenu
                } if ($(e.target).is('.meganav-submenu-inner-wrapper a')) {
                    //select previous submenu item
                    let anchor = $(e.target).prev('a');

                    //wrap to last item
                    if (anchor.length == 0) {
                        if ($(e.target).is('.nav-highlight a')) {
                            anchor = submenu.find('.nav-submenu-item').last();
                        } else {
                            anchor = submenu.find('a').last();
                        }
                    }

                    //focus previous submenu item
                    if (anchor.length > 0) {
                        anchor.addClass('keyboard-focus').on('blur', function () {
                            $(this).off('blur').removeClass('keyboard-focus');
                        }).get(0).focus();
                    }

                    return false;
                }
            }
        } else if (e.which == 37) { //left arrow

            submenu = menu.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
            submenuContainer = submenu.closest('.meganav-submenu-container');

            //find previous menu item
            let anchor = menu.closest('.trigger-container').prev('.trigger-container').find('.meganav-trigger, .standard-link');

            //wrap to last item
            if (anchor.length == 0) {
                anchor = menu.closest('.trigger-container').nextAll('.trigger-container').last().find('.meganav-trigger, .standard-link');
            }

            //close submenu
            let wasOpen = menu.is('.open');
            closeDesktopNav(menu);

            //focus previous menu item
            if (anchor.length > 0) {
                anchor.addClass('keyboard-focus').on("blur", function () {
                    $(this).off("blur").removeClass("keyboard-focus");
                }).get(0).focus();

                if (wasOpen) {
                    //open submenu
                    let newSubmenu = anchor.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
                    if (newSubmenu.length > 0) {
                        openDesktopNav(anchor);
                    }
                }

                return false;
            }

        } else if (e.which == 39) { //right arrow

            submenu = menu.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
            submenuContainer = submenu.closest('.meganav-submenu-container');

            //find next menu item
            let anchor = menu.closest('.trigger-container').next('.trigger-container').find('.meganav-trigger, .standard-link');

            //wrap to first item
            if (anchor.length == 0) {
                anchor = menu.closest('.trigger-container').prevAll('.trigger-container').last().find('.meganav-trigger, .standard-link'); //prevAll returns array ordered closest to furthest, not DOM order
            }

            //close submenu
            let wasOpen = menu.is('.open');
            closeDesktopNav(menu);

            //focus previous menu item
            if (anchor.length > 0) {
                anchor.addClass('keyboard-focus').on("blur", function () {
                    $(this).off("blur").removeClass("keyboard-focus");
                }).get(0).focus();

                if (wasOpen) {
                    //open submenu
                    let newSubmenu = anchor.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
                    if (newSubmenu.length > 0) {
                        openDesktopNav(anchor);
                    }
                }

                return false;
            }
        } else if (e.which == 36) { //home key

            submenu = menu.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
            submenuContainer = submenu.closest('.meganav-submenu-container');

            if ($(e.target).is('.meganav-trigger, .standard-link')) {

                if (menu.closest('.trigger-container').is(':first-child')) {
                    return false;
                }

                //find first menu item (prevAll returns array ordered closest to furthest, not DOM order)
                let anchor = menu.closest('.trigger-container').prevAll('.trigger-container').last().find('.meganav-trigger, .standard-link');

                //close submenu
                let wasOpen = menu.is('.open');
                closeDesktopNav(menu);

                //focus previous menu item
                if (anchor.length > 0) {
                    anchor.addClass('keyboard-focus').on("blur", function () {
                        $(this).off("blur").removeClass("keyboard-focus");
                    }).get(0).focus();

                    if (wasOpen) {
                        //open submenu
                        let newSubmenu = anchor.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
                        if (newSubmenu.length > 0) {
                            openDesktopNav(anchor);
                        }
                    }
                }

                return false;

            } else if ($(e.target).is('.meganav-submenu-inner-wrapper a')) {

                let anchor = submenu.find('a').first();

                //focus previous submenu item
                if (anchor.length > 0) {
                    anchor.addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();
                }

                return false;
            }
        } else if (e.which == 35) { //end key

            submenu = menu.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
            submenuContainer = submenu.closest('.meganav-submenu-container');

            if ($(e.target).is('.meganav-trigger, .standard-link')) {

                if (menu.closest('.trigger-container').is(':last-child')) {
                    return false;
                }

                //find last menu item
                let anchor = menu.closest('.trigger-container').nextAll('.trigger-container').last().find('.meganav-trigger, .standard-link');

                //close submenu
                let wasOpen = menu.is('.open');
                closeDesktopNav(menu);

                //focus previous menu item
                if (anchor.length > 0) {
                    anchor.addClass('keyboard-focus').on("blur", function () {
                        $(this).off("blur").removeClass("keyboard-focus");
                    }).get(0).focus();

                    if (wasOpen) {
                        //open submenu
                        let newSubmenu = anchor.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
                        if (newSubmenu.length > 0) {
                            openDesktopNav(anchor);
                        }
                    }
                }

                return false;

            } else if ($(e.target).is('.meganav-submenu-inner-wrapper a')) {
                //select last submenu item
                let anchor = submenu.find('a').last();

                //focus previous submenu item
                if (anchor.length > 0) {
                    anchor.addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();
                }

                return false;
            }
        } else if (e.which == 9) { //tab key
            submenu = menu.closest('.trigger-container').find('.meganav-submenu-inner-wrapper');
            submenuContainer = submenu.closest('.meganav-submenu-container');

            //if target is last anchor in last dropdown or last top-level nav in main nav, close the submenu
            if (
                (
                    !e.shiftKey &&
                    $(e.target).is('.meganav-trigger, .standard-link, .meganav-submenu-inner-wrapper a:last-child') &&
                    $(e.target).closest('.trigger-container').is(':last-child')
                ) || (
                    e.shiftKey &&
                    $(e.target).is('.meganav-trigger, .standard-link') &&
                    $(e.target).closest('.trigger-container').is(':first-child')
                )) {
                closeAllDesktopMainNavs();
            }
        }
    });
}

export { initMainNavKeyboardNavigation };